import { loadElementLazyImage } from './lazy-load'
import { smoothScrollPause, smoothScrollPlay } from '../scroll-smoother'
import { initGalleries } from '../sections/gallery'
import { initFinanceDocumentsFilter } from '../sections/finance-documents'
import { updateUrlParameter, getUrlParameter } from './helper-functions'
import { animateTableScroll } from '../global_events'


$(document).on('click', '.js-open-popup', function(){
  let findParent = $(this).data('popup-from-parent')
  let $el = findParent ? $(this).closest('.js-open-popup-parent') : $(this)
  let findContentInParent = $(this).data('search-popup-content-in-parent')

  let popupType = $el.data('popup-type')
  let setUrl = $el.data('popup-url')
  let content = $el.data('popup-content')
  let goToId = $el.data('go-to-id')

  if (!setUrl) setUrl = updateUrlParameter($('body').data('page-url'), 'popup', $el.data('popup-id'))

  if (!content) {
    if (findContentInParent) {
      content = $el.closest('.js-find-for-popup-content').find('.js-popup-content').clone().css('display', 'block')
    } else {
      content = $el.find('.js-popup-content').clone().css('display', 'block')
    }
  }

  openPopup(popupType, content, setUrl, goToId)

})



$('.js-close-popup').click(function(){
  let popup = $(this).closest('.js-popup')
  closePopup(popup)
})


$('.popup').click(function(e){
  let target = $(e.target)
  if (target.hasClass('popup-flex')) {
    let popup = target.closest('.js-popup')
    if (!popup.hasClass('js-cookies-popup'))
      closePopup(target.closest('.js-popup'))
  }
})

$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    closePopup($('.js-popup'))
  }
});


export function openPopupFromUrl(){
  let url = $('body').data('page-url')
  let popup = getUrlParameter(url, 'popup')
  let isMapPopup = getUrlParameter(url, 'maps-popup')

  if ($('.js-popup[data-popup="certificates-popup"]').css('display') === 'block') {
    smoothScrollPause()
  }

  if (popup){
    if (isMapPopup){
      let content = $('.js-locations-popup-content[data-id="'+ popup +'"]').clone().css('display', 'block')
      let popupType = 'default-popup'
      let setUrl = updateUrlParameter(url, 'popup', popup)
      setUrl = updateUrlParameter(setUrl, 'maps-popup', 1)

      openPopup(popupType, content, setUrl)

    } else {
      let popupEl = $('.js-open-popup[data-popup-id="' + popup + '"]')
      if (!popupEl.length) popupEl = $('.js-open-popup-parent[data-popup-id="' + popup + '"]').find('.js-open-popup').first()
      popupEl.click()
    }
  }
}



export function closePopup(popup){
  popup.fadeOut(400, function(){
    popup.find('video').each( ()=> this.pause() )
    popup.find('iframe').attr('src', '')
    //popup.find('video source').attr('src', '')
  })
  $('html').removeClass('modal-open')
  smoothScrollPlay()
  //smoothScrollCreate()

  let setUrl = updateUrlParameter($('body').data('page-url'), 'popup', '')
  setUrl = updateUrlParameter(setUrl, 'maps-popup', '')
  history.pushState({}, null, setUrl)
}


export function openPopup(popupType = 'default-popup', content = '', setUrl = '', goToId = ''){
  let popup = $('.js-popup[data-popup="'+popupType+'"]')
  if (popup.length) {
    let $content = popup.find('.js-popup-content')
    popup.fadeIn()
    $('html').addClass('modal-open')

    if (setUrl.length) window.history.pushState([], '', setUrl)

    // Scroll the popup to the top
    popup.scrollTop(0);

    smoothScrollPause()
    //smoothScrollKill()

    if (content.length){
      $content.html($(content))

      loadElementLazyImage($content.find('.lazy'))
      initGalleries($content.find('.js-gallery-block'))
      initFinanceDocumentsFilter($content.find('.js-finance-documents-filter'))
      animateTableScroll($content.find('.js-scroll-table-when-in-screen'))

    }

    if (goToId){
      setTimeout(function(){
        let goToEl = $content.find('[data-id="'+ goToId +'"]').first()
        let popupOffset = popup.offset().top
        let elTop = goToEl.offset().top
        let scroll = popup.scrollTop()
        let top = elTop - popupOffset + scroll - 20
        popup.animate({scrollTop: top}, 400);
      }, 400)
    }

  }
}






